import { graphql } from '@/gql';

graphql(`
  fragment EmailOptionsFragment on EmailOptionResponse {
    marketingEmails
    welcomeEmailForUsersWithPartners
    addPaymentSourceEmail
    updatePaymentSourceEmail
    defaultPaymentSourceEmail
    deletePaymentSourceEmail
    apologyRefundEmail
    blockDriverEmail
    cancellationFeeDisputeFailedEmail
    cancellationFeeDisputeSuccessEmail
    closingAccountEmail
    falseTripDisputeFailedEmail
    falseTripDisputeSuccessEmail
    fareDisputeFailedEmail
    fareDisputeSuccessEmail
    findLostItemFailedEmail
    refundEmail
    giftCardNotificationEmail
    giftCardReceiptEmail
    membershipRenewalReminderEmail
    membershipConfirmationEmail
    membershipFailedEmail
    membershipReceiptEmail
    membershipTrialConfirmationEmail
    membershipTrialWillEndEmail
    gogoGourmetReceiptEmail
    needLoveRefundEmail
    newRideCreditsNotificationEmail
    noPaymentMethodOnFileEmail
    noRidesCallerEmail
    noShowReceiptEmail
    partnerCreditsNotificationEmail
    partnerRidesNotificationEmail
    refundRideEmail
    rideCancellationReceiptEmail
    rideCreditsRenewalEmail
    rideHistoryEmail
    rideReceiptEmail
    scheduledRideCancelledEmail
    scheduledRideChangedEmail
    scheduledRideConfirmedEmail
    scheduledRideReminderDayBeforeEmail
    scheduledRideUnpaidServicesEmail
    scheduledRidePreauthFailedEmail
    scheduledGroceryCanceledEmail
    scheduledGroceryChangedEmail
    scheduledGroceryConfirmedEmail
    scheduledGroceryReminderEmail
    scheduledGroceryUnpaidServicesEmail
    scheduledGroceryPreauthFailedEmail
    scheduledDeliveryReminderEmail
    scheduledDeliveryUnpaidServicesEmail
    scheduledDeliveryPreauthFailedEmail
    surgePricingWasConfirmedEmail
    welcomeEmail
    deactivationPassedAwayEmail
    suspendingAccountMembershipEmail
    groceryReceiptEmail
    groceryReceivedEmail
    groceryOrderReminderEmail
    isAskedUserForEmail
    accountReactivateEmail
    driverCanceledEmail
    freeTrialReminderEmail
    groceryOrderUpdateEmail
    homeServicesReceiptEmail
    crmActivationCampaignEmail
    crmActivationHardRegistrationCampaignEmail
    crmMomentumEngagementCampaignEmail
    crmCrossSellGourmetCampaignEmail
    crmCrossSellGroceriesCampaignEmail
    crmCrossSellHomeServicesCampaignEmail
    crmReactivationCampaignEmail
    crmResurrectionCampaignEmail
    crmActivationDormantSoftRegistrationCampaignEmail
    crmActivationNewUserGroceryRegistrationEmail
    crmActivationDormantHardRegistrationCampaignEmail
    crmActivationNewUserAddedCCRegistrationEmail
    crmActivationNewUserGourmetRegistrationEmail
    crmActivationNewUserOnlineRegistrationEmail
    crmActivationNewUserPhoneRegistrationEmail
    crmActivationNewUserPickedPlanRegistrationEmail
    crmRevivalCampaignEmail
    refundDepositDeniedEmail
  }
`);
